var _style, _g, _path, _ellipse, _ellipse2, _path2, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAqe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "268px",
    height: "271px",
    viewBox: "0 0 268 271",
    style: {
      enableBackground: "new 0 0 268 271"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st3{opacity:0.9686;fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st5{display:none;fill:#FFFFFF;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st6{display:none;fill:#EFEEEE;}\r\n\t.st7{display:none;opacity:0.2784;fill:url(#SVGID_1_);enable-background:new    ;}\r\n\t.st8{display:none;opacity:0.3216;fill:url(#SVGID_2_);enable-background:new    ;}\r\n\t.st9{display:none;opacity:0.3294;fill:url(#SVGID_3_);enable-background:new    ;}\r\n\t.st10{display:none;opacity:0.251;fill:url(#SVGID_4_);enable-background:new    ;}\r\n\t.st11{display:none;opacity:0.349;fill:url(#SVGID_5_);enable-background:new    ;}\r\n\t.st12{display:none;}\r\n\t.st13{display:none;fill:none;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\r\n\t.st14{display:none;stroke:#000000;stroke-width:3.5;stroke-miterlimit:10;}\r\n\t.st15{display:none;fill:none;stroke:#000000;stroke-width:3.5;stroke-miterlimit:10;}\r\n\t.st16{display:none;fill:#FFFFFF;}\r\n\t.st17{display:none;fill:#EAC457;stroke:#EAC457;stroke-miterlimit:10;}\r\n\t.st18{display:none;fill:#EAC457;}\r\n\t.st19{display:none;fill:#EAC457;stroke:#000000;stroke-width:7;stroke-miterlimit:10;}\r\n\t.st20{display:none;opacity:0.2784;fill:url(#SVGID_6_);enable-background:new    ;}\r\n\t.st21{display:none;opacity:0.3216;fill:url(#SVGID_7_);enable-background:new    ;}\r\n\t.st22{display:none;opacity:0.3294;fill:url(#SVGID_8_);enable-background:new    ;}\r\n\t.st23{display:none;opacity:0.251;fill:url(#SVGID_9_);enable-background:new    ;}\r\n\t.st24{display:none;opacity:0.349;fill:url(#SVGID_10_);enable-background:new    ;}\r\n\t.st25{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st26{clip-path:url(#SVGID_12_);}\r\n\t.st27{clip-path:url(#SVGID_14_);}\r\n\t.st28{clip-path:url(#SVGID_16_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st29{clip-path:url(#SVGID_18_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st30{clip-path:url(#SVGID_20_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st31{clip-path:url(#SVGID_22_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st32{opacity:0.9686;clip-path:url(#SVGID_24_);enable-background:new    ;}\r\n\t.st33{clip-path:url(#SVGID_26_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st34{opacity:0.9686;clip-path:url(#SVGID_28_);enable-background:new    ;}\r\n\t.st35{clip-path:url(#SVGID_30_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st36{clip-path:url(#SVGID_32_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st37{clip-path:url(#SVGID_34_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st38{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st39{fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: -440.26,
    cy: 113.02,
    r: 537.5
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M65.29,99.11c4.25,5.07,8.51,7.5,5.33,8.7c-5.64,2.12-21.13-8.06-28.98-16.03 c-7.58,5.4-15.22,10.91-21.32,17.98c-6.1,7.08-10.63,15.97-10.83,25.39c-0.2,9.41,4.6,19.22,13,23.19 c19.75,9.33,41.56,14.1,63.33,13.87"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st25",
    cx: 106.53,
    cy: 68.15,
    rx: 23.17,
    ry: 23.58
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st25",
    cx: 163.19,
    cy: 68.15,
    rx: 23.17,
    ry: 23.58
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M129.69,69.16c0.19-2.08,2.54-3.87,5.11-3.9c2.57-0.02,4.97,1.73,5.2,3.81"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 79.64,
    y: 9.49,
    width: 113.8,
    height: 115.29
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_1_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 79.64,
    y: 9.49,
    width: 113.8,
    height: 115.29
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 79.64,
    y: 9.49,
    width: 113.8,
    height: 115.29
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_3_)",
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: "M163.97,108.67 c-6.51,3.99-18.83,7.11-29.86,7.11"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: 79.64,
    y: 9.49,
    width: 113.8,
    height: 115.29
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_4_)",
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: "M166.58,106.88 c-0.56,0.47-2.65,1.82-2.65,1.82L166.58,106.88z"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: 79.64,
    y: 9.49,
    width: 113.8,
    height: 115.29
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_5_)",
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: "M174.15,46.91 c12.84,7.51,12.41,17.36,12.41,23.69c0,15.96-12.02,29.54-20,36.3"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: 79.64,
    y: 9.49,
    width: 113.8,
    height: 115.29
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: "M134.24,115.79 c-28.47,0-53.69-20.38-51.49-45.12c0.61-6.94,0.36-16.58,13.65-24.28"
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: 79.64,
    y: 9.49,
    width: 113.8,
    height: 115.29
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9686,
      clipPath: "url(#SVGID_7_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 88.5,
    y: 18.27,
    width: 24.2,
    height: 28.61
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_8_)",
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: "M112.26,29.61 c-4.58-4.17-9.48-7.58-15.27-9.86c-2.02-0.86-4.34-1.42-6.08,0c-0.86,0.86-1.74,1.99-1.74,3.12 c-0.3,6.82,0.5,12.23,3.39,18.2c1.16,1.99,2.6,5.2,4.14,5.2"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: 79.64,
    y: 9.49,
    width: 113.8,
    height: 115.29
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9686,
      clipPath: "url(#SVGID_9_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: 156.62,
    y: 16.72,
    width: 31.18,
    height: 30.72
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_10_)",
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: "M173.52,46.91 c3.81-1.97,9.01-4.24,9.89-8.65c-2.46,0.58-4.12,0.63-6.6,1.12c4.09-2.54,7.63-6.04,9.73-10.35 c-1.99,0.76-3.89,1.74-5.88,2.52c1.68-4.22,2.84-9.33-0.06-13.3c-1.44-1.42-3.48-0.86-5.2-0.29 c-6.94,3.41-12.73,8.52-18.36,13.62"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: 79.64,
    y: 9.49,
    width: 113.8,
    height: 115.29
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_12_)",
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: "M159.46,29.39 c-0.85,0.57-1.19,1.77-2.15,2.14c-0.41,0.15-0.86,0.12-1.29,0.06c-4-0.52-7.51-2.78-11-4.76c-3.5-1.97-7.43-3.76-11.18-2.81 c4.7,0.93,8.93,3.87,11.11,8.03c-4.42-2.83-9.72-4.19-14.99-4.43c-5.27-0.24-9.62,0.86-14.73,2.19 c-1.11,0.29-2.51,0.52-3.21-0.37"
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: 79.64,
    y: 9.49,
    width: 113.8,
    height: 115.29
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_14_)",
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: "M177.12,24.29 c3.43-1.47-2.18,0.72-3.43,2.45c-1.47,2.02-6.68,7.69-7.1,10.15c-0.13,0.69-0.22,1.41-0.6,2.02c-0.8,1.3-2.56,1.61-4.09,1.68 c-5.6,0.26-11.18-0.9-16.79-0.84c-1.18,0.02-2.41,0.09-3.39,0.73c-1.6,1.04-2.23,3.35-4.08,3.87 c-2.02,0.57-3.75-1.38-5.28-2.77c-2.43-2.2-5.66-3.44-8.93-3.84c-3.28-0.41-6.61-0.03-9.86,0.64 c-1.82,0.38-3.65,0.87-5.52,0.73c-0.42-0.03-0.88-0.11-1.21-0.37c-0.38-0.29-0.53-0.75-0.69-1.19 c-1.33-3.75-3.26-7.28-5.71-10.43c-0.61-0.78-3.09-2.57-4.06-2.83c-2.98-0.76,3.53,1.01,3.98,2.83"
  })))))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M69.25,81.08c2.72-2.36,4.99-5.33,7.87-7.47c0.65-0.48,1.26-1.03,2.05-1.23c0.7-0.18,1.43-0.58,1.99,0.17 c0.51,0.68,0.44,1.47,0.09,2.3c-1.35,3.25-3.48,5.79-6.05,7.78c-3.99,3.11-8.16,5.92-12.16,9.02c-2.42,1.87-4.55,4.16-6.37,6.8 c-0.81,1.17-1.34,2.48-1.91,3.78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M73.04,68.96c1.51-1.77,2.35-3.54,1.85-5.62c-0.61-2.55-1.08-5.2-1.55-7.85c-0.12-0.7-0.58-0.85-0.98-1.13 c-0.79-0.54-1.87-0.39-2.74-0.87c-0.86-0.48-2.33,0.27-3.07,1.56c-0.86,1.49-1.73,1.83-2.9,2.14c-0.95,0.25-1.93,1.01-2.9,1.45 c-3.7,1.64-3.49,2.44-4.3,6.78c-0.5,2.71,0.2,4.97,0.6,7.33c0.47,2.77-0.19,5.14-2.6,7.81c-2.49,2.77-5.15,5.16-7.8,7.58 c-1.18,1.08-2.14,2.15-2.84,3.61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M75.48,48.92c-0.03-2.19,1.75-3.35,2.91-4.22c3.78-2.83,7.72-4.97,11.76-5.24c0.74-0.05,1.24,0.28,1.81,0.53 c0.76,0.32,0.85,1.19,0.68,2.07c-0.15,0.75-0.88,1.04-1.47,1.29c-2.23,0.97-4.46,1.9-6.68,2.93c-1.48,0.69-2.95,1.54-4.42,2.31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M69.37,53.21c1.34-2.11,4.51-4.02,6.31-3.9c1.15,0.08,1.85,0.82,2.14,1.89c0.95,3.43,1.84,6.9,1.6,11 c-0.06,1-0.61,1.83-0.81,2.73c-1.27,0.76-2.22-0.15-3.44,0.34"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M61.62,63.79c1.81-0.03,2.71,0.92,2.94,3.08c0.17,1.65,0.08,3.52,1.03,4.77c0.74,0.98,1.66,0.71,2.41-0.39 c0.99-1.46,1.9-2.93,1.71-4.87c-0.29-3.1-0.71-5.96-2.6-7.85c-0.54-0.53-0.82-1.4-1.22-2.11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M105.14,119.52c-0.89,2.5-0.59,8.83-1.1,11.74c-7.68-0.57-15.26-0.03-22.63,1.43"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M104.99,120.03c8.41,3.74,18.56,8.16,24.7,7.64c7.5-0.63,24.17-3.99,24.17-5.2c0,5,0.24,5.12,0.55,10.21 c7.87-0.63,12.15-1.58,16.94-1.69c14.16-1.88,28.96,7.57,34.27,21.87c9.32,25.13,15.73,51.52,19.04,78.36"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M179.87,160.48c10.44,21.62,16.48,45.36,17.63,69.35"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M85.31,166.09c1.4,21.57-2.47,43.34-11.33,63.8c-3.16,7.28,5.36,16.01,15.21,15.57 c27.96-1.24,55.93-2.48,83.89-3.72c4.49-0.2,8.37-3.5,8.22-7.01c-1.03-25.29-2.06-50.58-1.6-74.26"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M105.14,119.52c-0.89,2.5-0.59,8.83-1.1,11.74c-7.68-0.57-15.26-0.03-22.78,1.59 c-13.86,7.59-32.53,5.09-43.91-5.87"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M60.45,105.14c-8.55,6.76-14.33,16.38-17.8,26.02"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M195.78,230.34c9.25-4.22,20.5-3.77,29.39,1.18"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M220.1,229.49c4.11,7,7.09,14.54,8.81,22.33c0.26,1.18-0.6,2.48-1.89,2.85c-1.28,0.36-2.8-0.26-3.32-1.37 c-2.4-5.14-4.8-10.28-7.19-15.42c2.13,5.03,4.27,10.06,6.4,15.09c0.53,1.25-0.61,2.73-2.07,3.03c-1.45,0.3-2.98-0.35-3.97-1.34 s-1.52-2.28-1.97-3.55c-1.63-4.6-3.26-9.21-4.9-13.81c1.87,5.12,3.73,10.23,5.6,15.35c0.41,1.11-0.35,2.47-1.59,2.86 c-1.24,0.39-2.75-0.27-3.17-1.38c-2.13-5.59-4.27-11.17-6.4-16.76c-1.87,1.1-3.81,2.23-6.01,2.6c-2.19,0.38-4.73-0.18-5.93-1.85 c-1.2-1.67-0.3-4.43,1.89-4.81c2.85-0.49,5.7-0.98,8.55-1.47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAqe);
export default __webpack_public_path__ + "static/media/aqe.41996060e7a03b88ab5d7982465d0dec.svg";
export { ForwardRef as ReactComponent };